import React from 'react';
import { twMerge } from 'tailwind-merge';
import { RichTextFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { RichTextRenderer } from '@/ui/components/tileRenderers/RichTextRenderer';
import { CrystallizeContentHelper } from '@/utils/crystallize-content-helper';

interface NukiIdSubtextProps {
  subtext?: RichTextFragment | null;
  className?: string;
}

/**
 * Secondary helper line below the Smart Lock ID field. The copy comes from the Crystallize
 * component "nuki-id-subtext", so an empty component must leave no whitespace behind.
 */
export function NukiIdSubtext({ subtext, className }: Readonly<NukiIdSubtextProps>) {
  if (CrystallizeContentHelper.isRichTextEmpty(subtext)) {
    return null;
  }

  return (
    <div
      className={twMerge('mb-2 break-words text-sm text-neutral-50', className)}
      data-testid="nuki-id-subtext"
    >
      <RichTextRenderer blocks={subtext} openExternalLinksInNewTab />
    </div>
  );
}
